export default "__VITE_ASSET__C_HphIfg__"